export default __webpack_public_path__ + "680196fc5eca39f503594cc383aa660b.jpg";